import http from "../services/httpService";

const apiUrl = http.getApiUrl();
const endPoint = "/equipments/";
const url = apiUrl + endPoint;

export async function getEquipments() {
  return await http.get(url);
}

export async function getEquipmentById(equipmentId) {
  return await http.get(url + equipmentId);
}

export async function getMyEquipments() {
  return await http.get(url + "mine");
}

export async function getCustomerEquipments(customerId) {
  return await http.get(url + "user/" + customerId);
}

export async function getBillingCycles() {
  return await http.get(url + "billing-cycles");
}

export async function changeBillingCycle(equipmentId, newBillingCycleId) {
  return await http.put(url + "change-billing-cycle/" + equipmentId + "/" + newBillingCycleId);
}

export async function deleteEquipment(equipmentId) {
  return await http.delete(url + equipmentId);
}

export async function addEquipment(equipment) {
  return await http.post(url, equipment);
}

export async function updateEquipment(equipment) {
  const equipmentId = equipment._id;
  const payload = { ...equipment };
  delete payload._id;
  delete payload.billingCycleId;
  delete payload.allOLTs;
  delete payload.premium;
  delete payload.premiumValueType;
  return await http.put(url + equipmentId, payload);
}
